import { render, staticRenderFns } from "./Quantidade.vue?vue&type=template&id=67acbed2"
import script from "./Quantidade.vue?vue&type=script&lang=js"
export * from "./Quantidade.vue?vue&type=script&lang=js"
import style0 from "./Quantidade.vue?vue&type=style&index=0&id=67acbed2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports